function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#000000"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#555555",
  transform: "rotate(45,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#949494",
  transform: "rotate(90,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#cccccc",
  transform: "rotate(135,64,64)"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
  calcMode: "discrete",
  dur: "720ms",
  repeatCount: "indefinite"
}));

var SvgLoaderDownloadFile = function SvgLoaderDownloadFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoaderDownloadFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader-download-file.b68c4176.svg";
export { ForwardRef as ReactComponent };